import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import PropTypes from "prop-types";

import styles from "./styles";
import config from "../../data/config";

/** TODO:
 * - Rename.
 *  - Add propTypes
 *  - Add background color options
 *  - Use button object i.e <button />
 * */

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
      href: props.href ? props.href : config.signupURL
    };
  }

  static propTypes = {
    backgroundColor: PropTypes.string,
    className: PropTypes.string
  };

  render() {
    return (
      <a
        className={`${css(styles.CTASignup)} ${this.props.className}`}
        href={this.state.href}
        target={this.props.target}
        style={{ backgroundColor: `${this.props.backgroundColor || ""}` }}
      >
        {this.props.text}
      </a>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Buttons/SignUp.js